/*
 * Copyright (C) 2026 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { Component, OnInit } from '@angular/core';
import { SelectOption } from '@app/app/shared/styleguide/components/selects/sg-select/sg-select.component';
import { LucideArrowLeft, LucideEye, LucideEyeOff } from '@lucide/angular';
import { SignupDetailsFormComponent } from '../../signup-form/details-form/signup-details-form.component';

@Component({
  selector: 'ptl-v3-signup-details-form',
  templateUrl: './v3-signup-details-form.component.html',
  styleUrls: ['./v3-signup-details-form.component.scss'],
})
export class V3SignupDetailsFormComponent extends SignupDetailsFormComponent implements OnInit {
  protected readonly LucideEye = LucideEye;
  protected readonly LucideEyeOff = LucideEyeOff;
  protected readonly LucideArrowLeft = LucideArrowLeft;

  get affiliationOptions(): SelectOption<string>[] {
    return this.affiliations.map((affiliation) => ({ value: affiliation.key, label: affiliation.title }));
  }

  override ngOnInit(): void {
    super.ngOnInit();
    // The invitation flow prefills `email` from the validated token; keep it visible but not editable,
    // same intent as v2's `[readonly]` (ptl-sg-input has no readonly input, so disable the control instead).
    if (this.invitationId) {
      this.signupDetailsFormGroup.get('email')?.disable();
    }
  }
}
